import { render, staticRenderFns } from "./Page_Brands.vue?vue&type=template&id=606cdee0&scoped=true&"
import script from "./Page_Brands.vue?vue&type=script&lang=js&"
export * from "./Page_Brands.vue?vue&type=script&lang=js&"
import style0 from "./Page_Brands.vue?vue&type=style&index=0&id=606cdee0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606cdee0",
  null
  
)

export default component.exports